import { PolygonF } from "@react-google-maps/api";
import { useCallback, useRef, useState } from "react";

interface IProps {
  paths: any[];
  area: any;
  selectedArea: any;
  setSelectedArea: (val: any) => void;
  edit: boolean;
  setSelectedPolygon: (val: any) => void;
}

export const AreaPolygon = ({
  paths,
  selectedArea,
  area,
  setSelectedArea,
  edit,
  setSelectedPolygon,
}: IProps) => {
  const [polygonCoords, setPolygonCoords] = useState(paths);
  const polygonRef = useRef<any>(null);

  const onLoad = useCallback((polygon: any) => {
    polygonRef.current = polygon;
    // debugger;
    const path = polygon.getPaths();
    window.google.maps.event.addListener(polygon, "contextmenu", handleEdit);
    window.google.maps.event.addListener(polygon, "set_at", handleEdit);
    window.google.maps.event.addListener(polygon, "remove_at", handleEdit);
    // path.addListener("bounds_changed", handleEdit);
    // path.addListener("drag", handleEdit);
    // path.addListener("remove_at", handleEdit);
  }, []);

  const handleEdit = () => {
    console.log("handle edit called");
    const path = polygonRef.current.getPath();
    const newCoords = path.getArray().map((latLng: any) => {
      return { lat: latLng.lat(), lng: latLng.lng() };
    });
    setPolygonCoords(newCoords);
    console.log("Updated coordinates:", newCoords);
  };

  return (
    <PolygonF
      paths={polygonCoords}
      options={{
        strokeColor: "#1D4ED8", // generate random color hex
        strokeOpacity: 0.8,
        strokeWeight: selectedArea?.public_id === area.area_public_id ? 4 : 2,
        fillOpacity: 0.1,
        editable: selectedArea?.public_id === area.area_public_id && edit,
      }}
      onClick={() => {
        setSelectedArea({
          public_id: area.area_public_id,
          user_id: area.user_public_id,
          area_id: area.area_id,
          area_name: area.area_name,
          area_cordinates: area.area_cordinates
        });
        setSelectedPolygon(polygonRef.current);
      }}
      onLoad={onLoad}
    />
  );
};
